import { ButtonGroup, Dropdown } from 'semantic-ui-react';

import { Button, Table } from '~/components';
import { buildSpoofHref, stopRowClick } from '~/features/admin/adminUserListShared';

type CompanyTeamMemberActionsDropdownProps = {
  userId: string;
  email: string;
  locationSearch: string;
  isActive: boolean;
  togglePending: boolean;
  /** Disables Activate/Deactivate for the signed-in user row. */
  currentUserId?: string;
  onOpenEdit: () => void;
  onToggleActive: () => void;
};

/** Same pattern as admin Users list: primary Spoof + chevron dropdown (Update, Deactivate/Activate). */
export default function CompanyTeamMemberActionsDropdown({
  userId,
  email,
  locationSearch,
  isActive,
  togglePending,
  currentUserId,
  onOpenEdit,
  onToggleActive,
}: CompanyTeamMemberActionsDropdownProps) {
  const spoofHref = buildSpoofHref(email, locationSearch);
  const isSelf = currentUserId != null && userId === currentUserId;
  const canToggle = !isSelf;

  return (
    <Table.Cell textAlign="center" onClick={stopRowClick}>
      <ButtonGroup secondary size="tiny">
        <Button
          as="a"
          secondary
          href={spoofHref}
          target="_blank"
          onClick={stopRowClick}
          style={{
            padding: '8px 12px',
          }}
        >
          Spoof
        </Button>
        <Dropdown
          className="button icon"
          icon="dropdown"
          trigger={<></>}
          onClick={stopRowClick}
          style={{
            padding: '8px 12px',
            verticalAlign: 'middle',
            alignItems: 'center',
            display: 'flex',
            borderLeft: '1px solid #00446c',
          }}
        >
          <Dropdown.Menu>
            <Dropdown.Item text="Update" onClick={() => onOpenEdit()} />
            <Dropdown.Item
              text={isActive ? 'Deactivate' : 'Activate'}
              disabled={togglePending || !canToggle}
              onClick={() => onToggleActive()}
            />
          </Dropdown.Menu>
        </Dropdown>
      </ButtonGroup>
    </Table.Cell>
  );
}
